import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <ContactSection />
        <CardsSection />
        <AppSection />
        <AboutSection />
        <CommentsSection />
        <FeaturesSection />
        <MediaSection />
        <CarouselSection />
        <UpdatesSection />
        <RankingSection />
        <TopicsSection />
        <IndexSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}